import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Header,
  Modal,
  Form,
  Dropdown,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { required, phoneNumber } from '@mhub/web-validations';
import AppForm from '../../components/AppForm';
import PhoneInput from '../../components/AppForm/PhoneInput';
import INTL_CALL_CODES from '../../constants/intlCallCodes';
import { getPhoneValidRegex } from '../../utils/validations/phone';
import { isForeignCompany } from '../../utils/companies';
import { getItem } from '../../utils/storage';
import INTL_FLAG_CODES from '../../constants/intlFlagCodes';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import config from '../../../config';

class InviteBankerForm extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    bankOnCheck: PropTypes.func,
    banks: PropTypes.shape({
      data: PropTypes.array,
    }),
    auth: PropTypes.shape({
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    banks: state.banks,
  })
  constructor(props) {
    super(props);
    const auth = props.auth;
    let defaultCountryPhoneCode = '60';
    if (auth && isForeignCompany(auth.company)) {
      const idx = INTL_FLAG_CODES.findIndex(f => f.countryCode === auth.company.countryCode);
      if (idx !== -1) {
        defaultCountryPhoneCode = INTL_FLAG_CODES[idx].value;
      }
    }

    let phoneValidationPresets = {};
    const storePhoneValidationPresets = getItem(`${config.get('appName')}.phoneValidationPresets`);
    if (storePhoneValidationPresets) {
      try {
        phoneValidationPresets = JSON.parse(storePhoneValidationPresets).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }

    this.state = {
      mobilePrefix: defaultCountryPhoneCode,
      mobile: '',
      name: '',
      bankID: 0,
      errMessages: [],
      banksOptions: [],
      defaultCountryPhoneCode,
      phoneValidationPresets,
    };
    this.validation = {
      name: createRef(),
      bankID: createRef(),
      mobilePrefix: createRef(),
      mobile: createRef(),
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.resetData(() => {
        this.getBanksOptions(nextProps);
      });
    }
  }
  getBanksOptions = (props = this.props) => {
    const { banks, bankOnCheck } = props;
    const banksOptions = banks.data.map(bank => ({
      value: bank.id,
      text: bank.name,
      disabled: bankOnCheck ? bankOnCheck(bank) : false,
    }));
    const available = banksOptions.filter(b => !b.disabled);
    const bankID = available.length > 0 ? available[0].value : 0;
    this.setState({ banksOptions, bankID });
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  resetData = (cb = () => {}) => {
    const { defaultCountryPhoneCode } = this.state;
    this.setState({
      mobilePrefix: defaultCountryPhoneCode,
      mobile: '',
      name: '',
      bankID: 0,
    }, cb);
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { name, bankID, mobile, mobilePrefix } = this.state;
    const banker = {
      name,
      bankID: bankID.toString(),
      mobilePrefix,
      mobile,
    };
    return AppForm.validate(this.validation, banker)
      .then((validations) => {
        this.setState({
          errMessages: validations.filter(v => !v.isValid),
        });
        if (this.props.onConfirm) {
          this.props.onConfirm(event, validations, banker);
        }
      });
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnComfirm = (e) => {
    e.preventDefault();
    this.form.handleSubmit(event);
  }
  handleOnChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  }
  render() {
    const { t } = this.props;
    return (
      <Modal
        open={this.props.open === true}
        onClose={this.handleOnClose}
        closeIcon="close"
      >
        <Header icon="add" content={t('Invite banker')} />
        <Modal.Content>
          <Modal.Description>
            <p>{t('Please fill in banker detail')}.</p>
            <AppForm
              onSubmit={this.handleSubmit}
              error={this.state.errMessages.length > 0}
              ref={(ref) => { this.form = ref; }}
            >
              <AppForm.Input
                autoComplete="off"
                name="name"
                onChange={this.handleOnChange}
                label={t('Name')}
                ref={this.validation.name}
                validation={[required]}
                value={this.state.name}
              />
              <AppForm.Validate
                validation={[required]}
                ref={this.validation.bankID}
                onChange={this.handleOnChange}
                validateLabel={t('Bank')}
              >
                <Form.Field name="bankID">
                  <label htmlFor="bankID">{t('Bank')}</label>
                  <Dropdown
                    name="bankID"
                    selectOnBlur={false}
                    fluid selection search
                    floating scrolling className="icon"
                    onChange={(e, { value }) => this.handleOnChange(e, { value, name: 'bankID' })}
                    options={this.state.banksOptions}
                    value={this.state.bankID}
                  />
                </Form.Field>
              </AppForm.Validate>
              <Form.Group widths="equal">
                <AppForm.Validate
                  validation={[required]}
                  ref={this.validation.mobilePrefix}
                  onChange={this.handleOnChange}
                  validateLabel={t('{{label}} Prefix', { label: t('Mobile') })}
                >
                  <Form.Select
                    name="mobilePrefix"
                    onChange={this.handleOnChange}
                    options={INTL_CALL_CODES}
                    label={t('{{label}} Prefix', { label: t('Mobile') })}
                    search
                    selectOnBlur={false}
                    value={this.state.mobilePrefix}
                  />
                </AppForm.Validate>
                <PhoneInput
                  autoComplete="off"
                  name="mobile"
                  onChange={this.handleOnChange}
                  placeholder={this.state.mobilePrefix === '60' ? `${t('Mobile')}* (e.g. 196756118)` : `${t('Mobile')}*`}
                  label={this.state.mobilePrefix === '60' ? `${t('Mobile')}* (e.g. 196756118)` : `${t('Mobile')}*`}
                  prefix={this.state.mobilePrefix}
                  ref={this.validation.mobile}
                  type="tel"
                  validation={[required, {
                    validate: phoneNumber,
                    option: this.state.mobilePrefix === 'other' ? {} : {
                      isMobile: true,
                      phonePrefix: this.state.mobilePrefix,
                      validRegex: getPhoneValidRegex(
                        this.state.phoneValidationPresets,
                        this.state.mobilePrefix,
                        'mobile',
                      ),
                    },
                  }]}
                  value={this.state.mobile}
                  validateLabel={t('Mobile')}
                />
              </Form.Group>
            </AppForm>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button basic negative onClick={this.handleOnClose} icon="cancel" content={t('Cancel', { ns: TRANSLATION_FILES.translation })} inverted />
          <Button basic positive onClick={this.handleOnComfirm} icon="checkmark" content={t('Invite')} inverted />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(connect(InviteBankerForm.mapStateToProps)(InviteBankerForm));



// WEBPACK FOOTER //
// ./src/containers/modals/InviteBankerForm.jsx